// removed by extract-text-webpack-plugin
module.exports = {"speed":"speed","speed_metric":"speed_metric","speed_metric_row":"speed_metric_row","speed_metric_cell":"speed_metric_cell","dark":"dark"};


//////////////////
// WEBPACK FOOTER
// ./src/view/screens/Project/components/SpeedInfoBlock/style.scss
// module id = 1357
// module chunks = 0